import styled, { css } from 'styled-components';
import { SupportedThemeSize } from './sizes';

export type LevelState = 'not-started' | 'in-progress' | 'completed';

export const Badge = styled.span<{ $size: SupportedThemeSize; $state?: LevelState }>`
  ${({ theme, $size, $state }) => css`
    background-color: ${theme.co.primary20};
    border-radius: ${theme.bo.round};
    border: calc(${theme.sz[$size]} * 0.05) solid ${theme.co.primary0};
    box-shadow: 0 calc(${theme.sz[$size]} * 0.04) 0 0 ${theme.co.secondary90};

    display: inline-flex;
    align-items: center;
    justify-content: center;

    height: ${theme.sz[$size]};
    width: ${theme.sz[$size]};
    min-width: ${theme.sz[$size]};

    ${theme.typography.heading.desktop.accent.xl};
    font-size: calc(${theme.sz[$size]} * 0.6);
    line-height: calc(${theme.sz[$size]} * 0.6);

    ${$state === 'not-started' &&
    css`
      background-color: ${theme.co.secondary90};
      border-color: ${theme.co.secondary90};
      box-shadow: 0 calc(${theme.sz.s05} + ${theme.sz[$size]} / 80) 0 0 ${theme.co.secondary0};
      color: ${theme.co.secondary50};
    `}
  `}
`;
